(() => {
  const root = document.querySelector('[data-bs-root]');
  if (!root) return;
  const gallery = root.querySelector('[data-bs-gallery]');
  if (gallery) {
    const featured = gallery.querySelector('.bs-gallery-featured');
    const thumbs = [...gallery.querySelectorAll('.bs-gallery-thumb')];
    const dialog = gallery.querySelector('dialog');
    const enlarged = gallery.querySelector('.bs-gallery-enlarged');
    const track = gallery.querySelector('.bs-gallery-grid');
    const previous = gallery.querySelector('[data-bs-prev]');
    const next = gallery.querySelector('[data-bs-next]');
    let currentIndex = 0;
    function selectImage(index) {
      currentIndex = Math.max(0, Math.min(thumbs.length - 1, index));
      const thumb = thumbs[currentIndex];
      featured.srcset = thumb.dataset.bsSrcset;
      featured.src = thumb.dataset.bsImage;
      featured.alt = thumb.dataset.bsAlt;
      thumbs.forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
      gallery.querySelector('[data-bs-gallery-count]').textContent = `${currentIndex + 1} / ${thumbs.length}`;
      previous.disabled = currentIndex === 0;
      next.disabled = currentIndex === thumbs.length - 1;
      const bounds = thumb.getBoundingClientRect();
      const trackBounds = track.getBoundingClientRect();
      const delta = bounds.left < trackBounds.left ? bounds.left - trackBounds.left - 4 : bounds.right > trackBounds.right ? bounds.right - trackBounds.right + 4 : 0;
      if (delta) track.scrollBy({left: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => selectImage(index));
      thumb.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        selectImage(index + (event.key === 'ArrowLeft' ? -1 : 1));
        thumbs[currentIndex].focus({preventScroll: true});
      });
    });
    previous.addEventListener('click', () => selectImage(currentIndex - 1));
    next.addEventListener('click', () => selectImage(currentIndex + 1));
    gallery.querySelector('[data-bs-zoom]').addEventListener('click', () => {
      enlarged.src = featured.src;
      enlarged.alt = featured.alt;
      dialog.showModal();
    });
    gallery.querySelector('[data-bs-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  }
  const form = root.querySelector('#bs-product-form');
  if (!form) return;
  const cards = [...form.querySelectorAll('.bs-pack')];
  const loading = root.querySelector('.bs-form-loading');
  const money = new Intl.NumberFormat('es-CL', {style:'currency', currency:'CLP', maximumFractionDigits:0});
  let pendingCount = null;
  let pendingUntil = 0;
  let syncing = false;
  let retryTimer;
  const selected = () => form.querySelector('input[name="bs-pack"]:checked');
  function paint() {
    const choice = selected();
    if (!choice) return;
    cards.forEach(card => card.classList.toggle('is-selected', card.contains(choice)));
    root.querySelectorAll('[data-bs-price]').forEach(el => { el.textContent = money.format(Number(choice.dataset.price) / 100); });
    const title = choice.closest('.bs-pack').querySelector('.bs-pack-copy strong').textContent;
    root.querySelectorAll('[data-bs-count]').forEach(el => { el.textContent = title; });
    form.querySelector('[name="quantity"]').value = choice.dataset.count;
  }
  const nativeButton = () => root.querySelector('.bs-offer ._rsi-buy-now-button');
  function syncOffer() {
    clearTimeout(retryTimer);
    if (!pendingCount || Date.now() > pendingUntil) { pendingCount = null; return; }
    const offer = [...document.querySelectorAll('._rsi-quantity-offers-offer-container')].find(el => el.getClientRects().length && el.querySelector('._rsi-quantity-offers-title')?.textContent.trim().match(/^\d+/)?.[0] === pendingCount);
    if (offer && !offer.classList.contains('_rsi-quantity-offers-selected')) {
      syncing = true;
      offer.querySelector('._rsi-quantity-offers-offer')?.click();
      syncing = false;
    }
    if (offer?.classList.contains('_rsi-quantity-offers-selected')) { pendingCount = null; return; }
    retryTimer = setTimeout(syncOffer, 150);
  }
  function rememberSelection() {
    pendingCount = selected()?.dataset.count;
    pendingUntil = Date.now() + 10000;
    requestAnimationFrame(syncOffer);
  }
  function openForm() {
    const button = nativeButton();
    if (button) {
      if (loading) loading.hidden = true;
      rememberSelection();
      button.click();
    } else {
      if (loading) loading.hidden = false;
      form.scrollIntoView({behavior:'smooth',block:'center'});
    }
  }
  function enhanceModal() {
    const modal = document.querySelector('#_rsi-cod-form-modal-form');
    if (!modal) return;
    const hook = modal.querySelector('#rsi-cod-form-quantity-offers-hook');
    const lastField = modal.querySelector('#_rsi-field-city')?.closest('._rsi-modal-fields-item');
    if (hook && lastField && !hook.dataset.bsOrdered) {
      hook.dataset.bsOrdered = 'true';
      const intro = document.createElement('div');
      intro.className = 'bs-form-intro';
      const title = document.createElement('h2'); title.textContent = 'Elige tu plan SUPER HUMAN';
      const sub = document.createElement('p'); sub.textContent = 'Más frascos, mayor ahorro. Paga al recibir.';
      intro.append(title, sub); lastField.after(intro); intro.after(hook);
      const note = document.createElement('p'); note.className = 'bs-form-duration';
      note.textContent = 'Duración estimada con 2 cápsulas al día. Sigue la porción indicada en tu envase.';
      hook.after(note);
    }
    modal.querySelectorAll('._rsi-quantity-offers-offer img').forEach(img => {
      const white = 'https://cdn.shopify.com/s/files/1/0768/2883/6007/files/super-human-semilla-negra-fondo-blanco.png?v=1791487870';
      if (img.src !== white) img.src = white;
    });
    const submit = modal.querySelector('._rsi-modal-submit-button');
    if (submit) {
      submit.style.setProperty('background','linear-gradient(120deg,#1f5036,#133321)','important');
      submit.style.setProperty('color','#fff','important');
      submit.style.setProperty('border-radius','12px','important');
    }
  }
  function enhance() {
    enhanceModal();
    const button = nativeButton();
    if (!button || button.dataset.bsConnected) return;
    button.dataset.bsConnected = 'true';
    for (const [key,value] of Object.entries({background:'linear-gradient(115deg,#ebcc7e,#f4dfa7 55%,#dcb757)',color:'#172619','border-radius':'13px',border:'1px solid #d2ad51',padding:'14px 18px','font-size':'16px','min-height':'58px','box-shadow':'0 6px 18px #493c1324'})) button.style.setProperty(key,value,'important');
    button.setAttribute('role','button');
    button.setAttribute('tabindex','0');
    button.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); button.click(); } });
    if (loading) loading.hidden = true;
  }
  form.addEventListener('change', paint);
  form.addEventListener('submit', e => { e.preventDefault(); openForm(); });
  root.querySelectorAll('[data-bs-order]').forEach(button => button.addEventListener('click', openForm));
  document.addEventListener('click', event => {
    if (event.target.closest('.bs-offer ._rsi-buy-now-button')) rememberSelection();
    const offer = event.target.closest('._rsi-quantity-offers-offer-container');
    if (offer && !syncing) {
      pendingCount = null;
      const count = offer.querySelector('._rsi-quantity-offers-title')?.textContent.trim().match(/^\d+/)?.[0];
      const input = cards.map(card => card.querySelector('input')).find(input => input.dataset.count === count);
      if (input) { input.checked = true; paint(); }
    }
  },true);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1))) { enhance(); if (pendingCount) syncOffer(); }
  }).observe(document.body, {childList:true,subtree:true});
  paint(); enhance();
})();
